import React from 'react';
import { AuthStore } from './AuthStore';
import { ApplicationStore } from './ApplicationStore';
import { SettingsStore } from './SettingsStore';
import { EmailTemplateStore } from './EmailTemplateStore';
import { TildaStore } from './TildaStore';
import {DeploymentStore} from "./DeploymentStore";

class RootStore {
    authStore: AuthStore;
    applicationStore: ApplicationStore;
    settingsStore: SettingsStore;
    emailTemplateStore: EmailTemplateStore;
    tildaStore: TildaStore;
    deploymentStore: DeploymentStore;

    constructor() {
        this.authStore = new AuthStore();
        this.applicationStore = new ApplicationStore();
        this.settingsStore = new SettingsStore();
        this.emailTemplateStore = new EmailTemplateStore();
        this.tildaStore = new TildaStore();
        this.deploymentStore = new DeploymentStore();
    }

    // Метод для сброса всех данных (например, при logout)
    resetAllStores() {
        this.applicationStore.clearApplications();
        this.applicationStore.clearStatistics();
        this.settingsStore.clearSettings();
        this.emailTemplateStore.clearTemplates();
        this.emailTemplateStore.clearStats();
        this.tildaStore.clearForms();
        this.tildaStore.clearTags();
        this.tildaStore.clearEvents();
        this.tildaStore.clearTildaPages();
        this.deploymentStore.clearDeployments();
    }

    // Метод для сброса всех ошибок
    resetAllErrors() {
        this.authStore.resetError();
        this.applicationStore.resetError();
        this.settingsStore.resetError();
        this.emailTemplateStore.resetError();
        this.tildaStore.resetError();
        this.deploymentStore.resetError();
    }
}

// Создаем единственный экземпляр RootStore
const rootStore = new RootStore();

// Создаем контекст
const StoreContext = React.createContext<RootStore>(rootStore);

// Хук для использования store в компонентах
export const useStore = () => {
    const store = React.useContext(StoreContext);
    if (!store) {
        throw new Error('useStore must be used within a StoreProvider');
    }
    return store;
};

export default RootStore;